import { translateItemGemini, getGeminiApiKey, setGeminiApiKey } from './gemini'
import { translateItemDeepseek, getDeepseekApiKey, setDeepseekApiKey } from './deepseek'

export function getApiModel() {
  return localStorage.getItem('API_MODEL') || ''
}

export function setApiModel(aiType) {
  localStorage.setItem('API_MODEL', aiType)
}

export function getApiKey(aiType) {
  if (aiType === 'gemini') {
    return getGeminiApiKey()
  }
  if (aiType === 'deepseek') {
    return getDeepseekApiKey()
  }
  return ''
}

export function setApiKey(aiType, apiKey) {
  if (aiType === 'gemini') {
    return setGeminiApiKey(apiKey)
  }
  if (aiType === 'deepseek') {
    return setDeepseekApiKey(apiKey)
  }
  return () => { }
}

export async function translateItem(aiType, item, locales, columns, type) {
  if (aiType === 'gemini') {
    return await translateItemGemini(item, locales, columns, type)
  }
  if (aiType === 'deepseek') {
    return await translateItemDeepseek(item, locales, columns, type)
  }
  return () => { }
}
